import { render, staticRenderFns } from "./AddFarmLocationPopup.vue?vue&type=template&id=5735e411&scoped=true"
import script from "./AddFarmLocationPopup.vue?vue&type=script&lang=js"
export * from "./AddFarmLocationPopup.vue?vue&type=script&lang=js"
import style0 from "./AddFarmLocationPopup.vue?vue&type=style&index=0&id=5735e411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5735e411",
  null
  
)

export default component.exports